import { EcEnv } from '@castlery/config';
// import { salesRepLoggedInEvent } from '@castlery/modules-user-services';
import type { AppStartListening } from '@castlery/shared-redux-store';
import { Unsubscribe } from '@reduxjs/toolkit';
import {
  formatErrorMessage,
  checkoutProcessFailedEvent,
  refreshOrderAfterErrorEventNames,
  webProcessFailedEvent,
} from './error.helper';
import { getOrderByOrderNumber, selectCurrentOrderNumber } from '@castlery/modules-order-domain';
import { resetSelectedOfferId } from '@castlery/modules-product-domain';

export function setupCompositesListeners(startListening: AppStartListening, { modal }: { modal: any }): Unsubscribe {
  const subscriptions = [
    ...((EcEnv.NEXT_PUBLIC_CHANNEL === 'POS' && [
      startListening({
        matcher: checkoutProcessFailedEvent,
        effect: async (action, { dispatch, getState }) => {
          const message = formatErrorMessage(action);

          modal.warning({
            title: 'Oops!',
            subDesc: message,
            showCancelBtn: false,
            confirmText: 'Got it!',
            dialogSx: {
              width: 400,
            },
          });
          const { endpointName } = action.meta.arg;
          if (endpointName === 'addToOrder') {
            dispatch(resetSelectedOfferId());
          }
          if (refreshOrderAfterErrorEventNames.includes(endpointName)) {
            const orderNumber = selectCurrentOrderNumber(getState());
            orderNumber && (await dispatch(getOrderByOrderNumber.initiate(orderNumber)));
          }
        },
      }),
    ]) ||
      []),
    ...((EcEnv.NEXT_PUBLIC_CHANNEL === 'WEB' && [
      startListening({
        matcher: webProcessFailedEvent,
        effect: async (action, { dispatch, getState }) => {
          const message = formatErrorMessage(action);
          const { endpointName } = action.meta.arg;
          if (endpointName === 'addToOrder' || endpointName === 'updateWebOrder') {
            if (message.includes('maximum swatches in one order is 3')) {
              modal.warning({
                title: 'You’ve reached the maximum quantity',
                subDesc: 'You can add up to 3 free swatches to your cart.',
                showCancelBtn: false,
                confirmText: 'got it',
                dialogSx: {
                  textAlign: 'center',
                },
              });
            } else {
              modal.warning({
                title: 'Unable to add item to cart',
                subDesc: 'Something went wrong. Please try again later.',
                showCancelBtn: false,
                confirmText: 'CLOSE',
                dialogSx: {
                  textAlign: 'center',
                },
              });
            }

            return;
          }
          // modal.warning({
          //   title: 'Oops!',
          //   subDesc: message,
          //   showCancelBtn: false,
          //   confirmText: 'Got it!',
          // });
        },
      }),
    ]) ||
      []),
  ];

  return () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
  };
}
